import { useErrorHandlingMutation } from '@backoffice-frontend/data-fetching'
import {
  Body1,
  Divider,
  MoiaDialog,
  MoiaDialogContent,
  MoiaDialogFormFooter,
} from '@backoffice-frontend/patterns'
import { PersonArrowIcon } from '@moia-dev/pace-icons'
import { Button } from '@moia-dev/pace-web'
import type { SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { useAdVehicleStreamConfirmManualCheckInMutation } from './BoardingPassengers.hook'

export const CheckInPassengerDialog = ({
  tripId,
  vehicleId,
  isDialogOpen,
  setIsDialogOpen,
}: {
  tripId: string
  vehicleId: string
  isDialogOpen: boolean

  setIsDialogOpen: (isOpen: SetStateAction<boolean>) => void
}) => {
  const { t } = useTranslation()

  const [confirmManualCheckIn] = useErrorHandlingMutation(
    useAdVehicleStreamConfirmManualCheckInMutation,
  )

  const checkInPassenger = async () => {
    await confirmManualCheckIn({
      variables: {
        input: {
          tripId,
          vehicleId,
        },
      },
    })
    setIsDialogOpen(false)
  }

  return (
    <MoiaDialog
      maxWidth="xs"
      open={isDialogOpen}
      onClose={() => setIsDialogOpen(false)}
      header={t('adFleetMap_dialog_cscRemoteCheckinConfirmation_header')}
    >
      <Divider />
      <MoiaDialogContent>
        <Body1>
          {t('adFleetMap_dialog_cscRemoteCheckinConfirmation_caption')}
        </Body1>
      </MoiaDialogContent>
      <MoiaDialogFormFooter
        trailing={
          <>
            <Button
              label={t('common_cancel_button')}
              variant="secondary"
              onClick={() => setIsDialogOpen(false)}
            />
            <Button
              variant="primary"
              label={t('adFleetMap_dialog_cscRemoteCheckinConfirmation_button')}
              icon={<PersonArrowIcon />}
              onClick={checkInPassenger}
            />
          </>
        }
      />
    </MoiaDialog>
  )
}
